/** @jsxImportSource @emotion/react */
import React from "react";
import { Route, Routes } from "react-router-dom";
import ErrorView from "../components/404";

import Component from "../components/";

const WeddingRoute = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Component />} />
        <Route path="/guest/:to" element={<Component />} />
        <Route path="/to/:to" element={<Component />} />
        <Route
          path="*"
          element={<ErrorView text="Uh-oh, you're lost somewhere" />}
        />
      </Routes>
    </div>
  );
};

export default WeddingRoute;
